import React, { Component } from 'react';
import { Button, Form, Grid, GridColumn, Header, Icon, Segment, Tab } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive';
import FaqTable from './FAQTable';
import FAQEdit from './FAQEdit';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

class FAQ extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            userType: [],
            question: '',
            answer: '',
            data: [],
            roleKey: 'student'

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addFaq = this.addFaq.bind(this);
        this.resetValues = this.resetValues.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.showEditForm = this.showEditForm.bind(this);
        this.closeEditMode = this.closeEditMode.bind(this);
    }


    componentDidMount() {
        this.fetchData();
        axios.get('/user-types')
            .then(res => {
                const roleOptions = res.data.sort((a, b) => a.name.localeCompare(b.name)).map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    roleOptions
                });
            }).catch(err => {

            });
    }

    handleTabChange(e, { activeIndex }) {
        if (activeIndex === 0) this.setState({ roleKey: 'student', activeIndex }, () => this.fetchData());
        if (activeIndex === 1) this.setState({ roleKey: 'student_service', activeIndex }, () => this.fetchData());
        if (activeIndex === 2) this.setState({ roleKey: 'professor', activeIndex }, () => this.fetchData());
        if (activeIndex === 3) this.setState({ roleKey: 'assistant', activeIndex }, () => this.fetchData());
        if (activeIndex === 4) this.setState({ roleKey: 'hr_admin', activeIndex }, () => this.fetchData());
        if (activeIndex === 5) this.setState({ roleKey: 'hr_faculty_admin', activeIndex }, () => this.fetchData());
        if (activeIndex === 6) this.setState({ roleKey: 'qa_admin', activeIndex }, () => this.fetchData());
        if (activeIndex === 7) this.setState({ roleKey: 'qa_faculty_admin', activeIndex }, () => this.fetchData());
    }

    resetValues() {
        this.setState({
            role: [],
            question: null,
            answer: null,
        });
    }

    addFaq(role, question, answer) {
        if (!question || !answer) {
            if (!question) { this.setState({ questionErr: true }); } else { this.setState({ questionErr: false }); }
            if (!answer) { this.setState({ answerErr: true }); } else { this.setState({ answerErr: false }); }
            // if (role.length === 0) { this.setState({ roleErr: true }); } else { this.setState({ roleErr: false }); }

            toast('Morate unijeti obavezna polja');
        } else {
            let userTypes = this.state.role.map(e => ({ id: e }));
            let newFaq = {
                userTypes,
                question: this.state.question,
                answer: this.state.answer,


            };


            axios.post('/faq/add', { ...newFaq })
                .then(res => {
                    this.setState({ showAddForm: false });
                    toast('Uspješno ste kreirali pitanje!');
                    this.resetValues();
                    this.fetchData();
                })
                .catch(err => {
                    toast('Došlo je do greške! Kreiranje pitanja nije uspjelo.');
                });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    closeEditMode() {
        this.setState({ showEditForm: false });
    }

    fetchData() {
        axios.get(`/faq/by-user-type-key/${this.state.roleKey}`)
            .then(res => {
                this.setState({ data: res.data });
            });
    }
    showEditForm() {
        this.setState({ showEditForm: true, showAddForm: false });
    }
    render() {
        const panes = [

            {
                menuItem: 'Student',
                render: () => (<Tab.Pane attached={false} as={Responsive}>


                    <FaqTable roleType="student" data={this.state.data} fetchData={this.fetchData} showEditForm={this.showEditForm} />


                </Tab.Pane>)
            },
            {
                menuItem: 'Studentska služba',
                render: () => (<Tab.Pane attached={false} as={Responsive}>

                    <FaqTable roleType="Studentska služba" data={this.state.data} fetchData={this.fetchData} showEditForm={this.showEditForm} />


                </Tab.Pane>)
            },
            {
                menuItem: 'Profesor',
                render: () => (<Tab.Pane attached={false} as={Responsive}>

                    <FaqTable roleType="Profesor" data={this.state.data} fetchData={this.fetchData} showEditForm={this.showEditForm} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Asistent',
                render: () => (<Tab.Pane attached={false} as={Responsive}>

                    <FaqTable roleType="Asistent" data={this.state.data} fetchData={this.fetchData} showEditForm={this.showEditForm} />
                </Tab.Pane>)
            },
            localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && {
                menuItem: 'HR admin ',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <FaqTable roleType="HR admin" data={this.state.data} fetchData={this.fetchData} showEditForm={this.showEditForm} />

                </Tab.Pane>)
            },
            {
                menuItem: 'HR admin - OJ',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <FaqTable roleType="HR admin - OJ" data={this.state.data} fetchData={this.fetchData} showEditForm={this.showEditForm} />

                </Tab.Pane>)
            },
            localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && {
                menuItem: 'QA admin',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <FaqTable roleType="QA admin" data={this.state.data}fetchData={this.fetchData} showEditForm={this.showEditForm} />

                </Tab.Pane>)
            },
            {
                menuItem: 'QA admin - OJ',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <FaqTable roleType="QA admin - OJ" data={this.state.data} fetchData={this.fetchData} showEditForm={this.showEditForm} />

                </Tab.Pane>)
            }
        ];
        return (

            <div>
                <h1>{localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' ? 'Pitanja i odgovori' : 'FAQ'}</h1>
                <Segment.Group raised>
                    <Segment >
                        {localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' ?
                            <h3> Najčešće postavljena pitanja
                                {!this.state.showAddForm && <Header style={IconHeader} floated="right" >  <Button
                                    disabled={localStorage.getItem('activeRole') === 'Support'}
                                    color="blue"
                                    floated="right"
                                    icon
                                    labelPosition="right"
                                    size="small"
                                    style={FiltersOnStyle}
                                    onClick={() => this.setState({ showAddForm: true, showEditForm: false })}
                                ><Icon className="add" />
                                    Kreiraj pitanje i odgovor
                                </Button>
                                </Header>}
                            </h3>

                            : <h3> Najčešće postavljena pitanja</h3>}
                    </Segment>
                    {(this.state.showAddForm) && <Segment>
                        <Segment clearing secondary>
                            <Form>
                                <Grid columns={2} >
                                    <GridColumn>
                                        <Form.Field required error={this.state.roleErr}>
                                            <label>Uloga</label>
                                            <Form.Dropdown
                                                multiple
                                                placeholder="Odaberite ulogu"
                                                value={this.state.role}
                                                onChange={this.handleInputChange}
                                                name="role"
                                                options={this.state.roleOptions}
                                                search
                                                fluid
                                                selection

                                            />
                                        </Form.Field>
                                        <Form.Field required>

                                            <label>Pitanje</label>
                                            <Form.TextArea
                                                placeholder="Unesite pitanje"
                                                rows={3}
                                                onChange={this.handleInputChange}
                                                value={this.state.question}
                                                name="question"
                                                error={this.state.questionErr}
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                    <GridColumn>
                                        <Form.Field width="16" type="textarea" required>
                                            <label>Odgovor</label>
                                            <Form.TextArea
                                                placeholder="Unesite odgovor"
                                                rows={7}
                                                onChange={this.handleInputChange}
                                                value={this.state.answer}
                                                name="answer"
                                                error={this.state.answerErr}
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                </Grid>
                                <br />
                                <Button floated="right" color="blue" onClick={() => this.setState({ showAddForm: false })} basic>Odustani</Button>
                                <Button
                                    floated="right"
                                    color="blue"
                                    onClick={
                                        () => {
                                            this.addFaq(
                                                this.state.userType,
                                                this.state.question,

                                                this.state.answer,
                                            );
                                        }
                                    }
                                >Dodaj</Button>
                            </Form>
                        </Segment>
                    </Segment>}
                    {(this.state.showEditForm) && <FAQEdit
                        closeEditMode={this.closeEditMode}
                        fetchData={this.fetchData}
                    />}


                    <Segment>
                        <Tab
                            id="myTab"
                            menu={{ secondary: true, pointing: true, color: 'blue' }}
                            panes={panes}
                            activeIndex={this.state.activeIndex}
                            onTabChange={this.handleTabChange}
                        />
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>

            </div>
        );
    }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/views/Admin/FAQ/FAQ.js